import React from 'react'
import { Button } from '@material-ui/core'
import './Login.css'
import { auth, provider } from './firebase';
import { useStateValue } from './StateProvider';
import { actionTypes } from './reducer';

function Login() {
    const [state, dispatch] = useStateValue();  
    //that state value will be dispatched as user in app.js

    const signIn = () => {
      // sign in with promise request
      auth.signInWithPopup(provider)
      .then((result) => {
         dispatch({
             type: actionTypes.SET_USER,
             user: result.user,
         })
      })
      .catch((error) => alert(error.message));
    };
    return (
        <div className="login">
            <div className="login__logo">
                <img 
                  src="https://facebookbrand.com/wp-content/uploads/2019/04/f_logo_RGB-Hex-Blue_512.png?w=512&h=512"
               alt="logo" />
                <img
                src="https://cdn.pixabay.com/photo/2015/12/04/23/39/facebook-1077639_960_720.jpg"
               alt="fb" />
            </div>
            <Button type="submit" onClick={signIn}
            >
                Sign In
            </Button>
            
        </div>
    )
}

export default Login
